<div class="card p-4">
  <div class="card-body d-flex justify-content-between align-items-center">
    <h5 class="card-title text-uppercase">Tabla presuntiva Banca Virtual - Riobamba</h5>
  </div>
  <div class="d-flex">
    <div class="d-flex flex-column p-2 mr-4">
      <span class="box-title">Capital</span>
      <span class="box-subtitle">{{ tabla?.capital | currency }}</span>
    </div>
    <div class="d-flex flex-column p-2 mr-4">
      <span class="box-title">Interés</span>
      <span class="box-subtitle">{{ tabla?.interes | currency }}</span>
    </div>
    <div class="d-flex flex-column p-2">
      <span class="box-title">Valor Impuesto (-)</span>
      <span class="box-subtitle">{{ tabla?.valorImpuesto | currency }}</span>
    </div>
    <div class="d-flex flex-column p-2">
      <span class="box-title">Neto a recibir</span>
      <span class="box-subtitle">{{ tabla?.netoRecibir | currency }}</span>
    </div>
  </div>
  <table class="table">
    <thead>
      <tr>
        <th scope="col" class="text-uppercase border-top-none">N° Cuota</th>
        <th scope="col" class="text-uppercase border-top-none">Fecha Pago</th>
        <th scope="col" class="text-uppercase border-top-none">Día Pago</th>
        <th scope="col" class="text-uppercase border-top-none">N° Día</th>
        <th scope="col" class="text-uppercase border-top-none">Capital</th>
        <th scope="col" class="text-uppercase border-top-none">Interés</th>
        <th scope="col" class="text-uppercase border-top-none">Retención</th>
        <th scope="col" class="text-uppercase border-top-none">A Recibir</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let fila of tabla?.tablaPresuntivaDepositoParaImpresionDetalles; let i = index">
        <td>{{ i + 1 }}</td>
        <td>{{ fila?.fechaPago | date: 'dd/MM/yyyy'}}</td>
        <td>{{ fila?.diaPago }}</td>
        <td>{{ fila?.numeroDias }}</td>
        <td class="text-right">{{ fila?.capital | currency }}</td>
        <td class="text-right">{{ fila?.interes | currency }}</td>
        <td class="text-right">{{ fila?.retencion | currency }}</td>
        <td class="text-right">{{ fila?.aRecibir | currency }}</td>
      </tr>
    </tbody>
  </table>
</div>
